import { createFileRoute, notFound } from "@tanstack/react-router";

import { ChangelogPage } from "@/components/marketing/changelog-page";
import { MARKETING_FLAGS } from "@/lib/marketing-flags";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/changelog")({
  // A flagged-off page answers 404. It used to redirect home, which Google
  // treats as a soft 404, and robots.txt hid even that.
  beforeLoad: () => {
    if (!MARKETING_FLAGS.changelog) {
      throw notFound();
    }
  },
  head: () => pageHead("changelog"),
  component: ChangelogPage,
});
